/** Russian plurals: "1 товар / 2 товара / 5 товаров" (docs/frontend/README.md). */
export type PluralForms = readonly [one: string, few: string, many: string]

export function pluralRu(count: number, forms: PluralForms): string {
  const n = Math.abs(Math.trunc(count))
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return forms[0]
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1]
  return forms[2]
}

/** 5 → "5 товаров". */
export function withCountRu(count: number, forms: PluralForms): string {
  return `${count} ${pluralRu(count, forms)}`
}
